import React, { useState, useEffect } from "react";
import NetworkErrorMessage from "./NetworkErrorMessage";
import { provider } from '../ethereum/web3';

interface ConnectWalletProps {
  connectWallet?: () => void;
  networkError?: string;
  dismiss?: () => void;
}

// export const Function:FC <Props> = () => {};
export default function ConnectWallet(props: ConnectWalletProps): JSX.Element {
  const [walletAddress, setWalletAddress] = useState<string>('');

  useEffect(() => {
    async function getAccountId() {
      const accounts = await provider.listAccounts();
      if (!accounts.length) {
        return;
      }
      const strLen = accounts[0].length;
      setWalletAddress(accounts[0].substring(0,5) + '...' + accounts[0].substring(strLen - 4, strLen));
    }
    getAccountId();
  }, [setWalletAddress]);

  return (
    <div className="container" style={{ marginTop: '14px' }}>
      <div className="row justify-content-md-center">
        <div className="col-6 p-4 text-center">
          <button
            className="btn btn-warning"
            type="button"
            onClick={props.connectWallet}
          >
            { walletAddress ? walletAddress : "Connect Wallet" }
          </button>
        </div>
      </div>
    </div>
  );
}
